/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What can I put in a QR code?`)
};

const es_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué puedo poner en un código QR?`)
};

const de_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was kann ich in einen QR-Code packen?`)
};

const nl_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat kan ik in een QR-code zetten?`)
};

const fr_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que puis-je mettre dans un QR code ?`)
};

const it_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa posso inserire in un codice QR?`)
};

const pt_br2_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que posso colocar em um código QR?`)
};

const pt_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que posso colocar num código QR?`)
};

const ja_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QRコードには何を入れられますか?`)
};

const zh_qr_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二维码中可以放什么内容？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_q1", locale)
	if (locale === "en") return en_qr_faq_q1(inputs)
	if (locale === "es") return es_qr_faq_q1(inputs)
	if (locale === "de") return de_qr_faq_q1(inputs)
	if (locale === "nl") return nl_qr_faq_q1(inputs)
	if (locale === "fr") return fr_qr_faq_q1(inputs)
	if (locale === "it") return it_qr_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_q1(inputs)
	if (locale === "pt") return pt_qr_faq_q1(inputs)
	if (locale === "ja") return ja_qr_faq_q1(inputs)
	return zh_qr_faq_q1(inputs)
};